import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-semibold tracking-wide tabular-nums ring-1',
  {
    variants: {
      tone: {
        primary: 'bg-primary/15 text-foreground ring-primary/30',
        info: 'bg-sky-500/12 text-sky-700 ring-sky-500/25 dark:text-sky-300',
        success:
          'bg-emerald-500/12 text-emerald-700 ring-emerald-500/25 dark:text-emerald-300',
        warning:
          'bg-amber-500/12 text-amber-700 ring-amber-500/25 dark:text-amber-300',
        danger:
          'bg-rose-500/12 text-rose-700 ring-rose-500/25 dark:text-rose-300',
        neutral:
          'bg-foreground/5 text-muted-foreground ring-foreground/10',
      },
    },
    defaultVariants: {
      tone: 'neutral',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, tone, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ tone }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
